import { helpers } from "vuelidate/lib/validators";

export const webValidator = helpers.regex("webValidator", /^\S+$/m);